<template>
    <div class="roadblock">
        <div class="rb-content animated slideInUp">
            <h1>Case Update #1234-56</h1>
            <p>API and LE meet with the local DA to devise a plan for taking out this fence operation.</p>
            <p>They decide to coordinate an undercover sale to the pawn shop utilizing Rob O’Toole as a confidential informant.</p>
        </div>
        <router-link to="/pawn-shop-owner">
            <NextButton />
        </router-link>
    </div>
</template>

<script>
import NextButton from '@/components/NextButton.vue'

export default {
  name: 'blitz',
  components: {
    NextButton
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
.roadblock {
    background: url("~@/assets/roadblock-bg.jpg") center center no-repeat;
    background-size: cover;
    height: 100%;
    width: 100%;
}

.rb-content {
    text-align: left;
    background: url("~@/assets/roadblock-modal.png") center center no-repeat;
    background-size: cover;
    width: 392px;
    height: 261px;
    position: absolute;
    top: 60px;
    left: 140px;
}

h1 { 
    color: #fff;
    padding: 30px 0 20px 80px;
    font-size: 28px;
}
p {
    color: #4A4A4A;
    padding: 0 30px;
    font-size: 18px;
}
</style>
